import sharedAvailabilityModule from '../../../admin/app/modules/shared/availability';
import sharedBaseModule from '../../../admin/app/modules/shared/base';
import sharedGuestModule from '../../../admin/app/modules/shared/guest';
import sharedItemModule from '../../../admin/app/modules/shared/item';
import sharedCheckoutModule from '../../../admin/app/modules/shared/checkout';
import sharedCoreModule from '../../../admin/app/modules/shared/journey-ui/core';
import sharedPaymentModule from '../../../admin/app/modules/shared/journey-ui/payment';
import sharedServicesModule from '../../../admin/app/modules/shared/journey-ui/services';
import basketModule from './basket';
import guestModule from './guest';
import pageModule from './page';
import widgetModule from './widget';
import popupModule from './popup';
import checkoutModule from './checkout';
import storefrontOrderModule from './order';
import availabilityModule from './availability';
import userModule from './user';

export const modules = [
  sharedAvailabilityModule,
  sharedBaseModule,
  sharedGuestModule,
  sharedItemModule,
  sharedCheckoutModule,
  sharedCoreModule,
  sharedPaymentModule,
  sharedServicesModule,
  guestModule,
  pageModule,
  basketModule,
  widgetModule,
  popupModule,
  checkoutModule,
  storefrontOrderModule,
  availabilityModule,
  userModule,
];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/index.js